import React, { Component } from 'react'
import { connect } from 'react-redux'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import TextArea from '../../front/components/shared/sn-textarea'
import {
    setAchievementSportAction,
    setAchievementTextAction,
} from '../../admin/actions/on-boarding'
import inOnBoarding, { ON_BOARDING_STEP_ACHIEVEMENT } from './hoc'
import SportSelection from '../../admin/components/shared/sport-selection/sport-selection'
import { storeAchievement } from './actions'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_ACHIEVEMENT)
class AchievementOnBoarding extends Component {

    state = {
        value: '',
    }

    /**
     * Submit data to backend and call onFinish
     */
    finishClicked = () => {
        const {
            userData,
            user,
            onFinish,
        } = this.props

        const achievementData = {
            sport_id: userData.achievementSport.value,
            description: userData.achievementText,
        }

        return storeAchievement(achievementData, user.slug)
            .then(() => {
                if (typeof onFinish === 'function') {
                    onFinish()
                }
            })
    }

    /**
     * Update selected sport for achievement
     * @param {Array} selectedSports
     */
    updateSelectedSports = selectedSports => {
        if (selectedSports && selectedSports.length > 0) {
            setAchievementSportAction(selectedSports[0])
            return
        }

        setAchievementSportAction(null)
    }

    render = () => {
        const {
            fetchedSports,
            userData,
            t,
        } = this.props

        if (!fetchedSports) {
            return null
        }

        const mappedSports = fetchedSports.map(sport => ({
            value: sport.id,
            label: sport.name,
        }))

        const selectedSport = userData?.achievementSport
        const typedText = userData?.achievementText

        return (
            <div className="d-flex flex-column">
                <span className="text-color-gray-dark-1 font-weight-bold font-size-xl mb-2">
                    {t('onBoardingAchievementTitle')}
                </span>
                <span className="text-color-gray-dark-1 font-size-sm mb-2">
                    {t('onBoardingAchievementSubtitle')}
                </span>
                <SportSelection
                    singleSport
                    centered
                    sports={mappedSports}
                    updateSelectedSports={this.updateSelectedSports}
                    preselectedSport={selectedSport || userData?.sport?.[0]}
                    selectedSports={selectedSport ? [selectedSport] : []}
                    hideAddSport={true}
                    inputContainerClassName="col-12 col-md-7"
                />
                <TextArea
                    label={t('onBoardingAchievementSubtitleSecond')}
                    labelClassName="text-color-gray-dark-1 font-size-sm"
                    value={typedText}
                    onChange={e => setAchievementTextAction(e.target.value)}
                />
                <div className="d-flex justify-content-between mt-4">
                    <Button
                        className="btn btn-color-brand btn-circle"
                        onClick={this.finishClicked}
                        disabled={!selectedSport && !typedText}
                    >
                        {t('finish')}
                    </Button>
                    <Button
                        className="btn btn-outline-color-gray-dark-3 btn-circle"
                        onClick={this.finishClicked}
                    >
                        {t('skip')}
                    </Button>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    userData: state.onBoarding.userData,
    fetchedSports: state.onBoarding.sports,
}))(AchievementOnBoarding)
